// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comments {
  display: grid;
  gap: 16px;
  margin-top: 24px;
  padding: 24px 0;
  border-top: 1px solid #d9dde4;
}

.comments h2 {
  margin: 0;
}

.comments-message {
  margin: 0;
  color: #1f5a99;
  font-weight: 700;
}

.comment-form,
.comment-list {
  display: grid;
  gap: 12px;
}

.comment-form input,
.comment-form textarea,
.comment-item input,
.comment-item textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #cbd3dc;
  border-radius: 6px;
  padding: 10px 12px;
  font: inherit;
}

.comment-form textarea,
.comment-item textarea {
  min-height: 92px;
  resize: vertical;
}

.comment-form button,
.comment-actions button {
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid #cbd3dc;
  border-radius: 6px;
  background: #fff;
  color: #1f5a99;
  cursor: pointer;
  font-weight: 700;
}

.comment-form button {
  justify-self: start;
  background: #1f5a99;
  color: #fff;
}

.comment-item {
  display: grid;
  gap: 8px;
  padding: 14px;
  border: 1px solid #e1e5ea;
  border-radius: 8px;
  background: #f7f9fb;
}

.comment-item header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #3d4652;
}

.comment-item p {
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.comment-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.comment-rejected {
  opacity: 0.65;
}
`, "",{"version":3,"sources":["webpack://./src/Comments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;;;;EAIE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;AACf","sourcesContent":[".comments {\n  display: grid;\n  gap: 16px;\n  margin-top: 24px;\n  padding: 24px 0;\n  border-top: 1px solid #d9dde4;\n}\n\n.comments h2 {\n  margin: 0;\n}\n\n.comments-message {\n  margin: 0;\n  color: #1f5a99;\n  font-weight: 700;\n}\n\n.comment-form,\n.comment-list {\n  display: grid;\n  gap: 12px;\n}\n\n.comment-form input,\n.comment-form textarea,\n.comment-item input,\n.comment-item textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #cbd3dc;\n  border-radius: 6px;\n  padding: 10px 12px;\n  font: inherit;\n}\n\n.comment-form textarea,\n.comment-item textarea {\n  min-height: 92px;\n  resize: vertical;\n}\n\n.comment-form button,\n.comment-actions button {\n  min-height: 36px;\n  padding: 0 14px;\n  border: 1px solid #cbd3dc;\n  border-radius: 6px;\n  background: #fff;\n  color: #1f5a99;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.comment-form button {\n  justify-self: start;\n  background: #1f5a99;\n  color: #fff;\n}\n\n.comment-item {\n  display: grid;\n  gap: 8px;\n  padding: 14px;\n  border: 1px solid #e1e5ea;\n  border-radius: 8px;\n  background: #f7f9fb;\n}\n\n.comment-item header {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  color: #3d4652;\n}\n\n.comment-item p {\n  margin: 0;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.comment-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.comment-rejected {\n  opacity: 0.65;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
